"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var ramda_1 = require("ramda");
var utils_1 = require("../../utils/utils");
var errors_1 = require("../../errors");
var ResponseError_1 = __importDefault(require("../../errors/ResponseError"));
var logging_1 = __importDefault(require("../../logging"));
var getResponseData = function (response) {
    return ramda_1.path(['data', 'data'], response) || ramda_1.path(['data'], response) || response;
};
var getResponseEtag = function (response) { var _a, _b, _c; return ((_a = response.headers) === null || _a === void 0 ? void 0 : _a.etag) || ((_c = (_b = response.headers) === null || _b === void 0 ? void 0 : _b.get) === null || _c === void 0 ? void 0 : _c.call(_b, 'etag')) || undefined; };
/**
 *  A graphql error resopnse will be of following types
  Type 1: Data with attributes null Values
  {
          "errors": [
            {
              "message": "Unexpected error occurred",
              "locations": [
                {
                  "line": 2,
                  "column": 2
                }
              ],
              "path": [
                "group"
              ],
              "extensions": {
                "errorId": "9ef691af-cc84-46cd-a4e1-25ed37c5f72d",
                "stacktrace": [
                  "graphql.GraphqlErrorException",
                  "    at graphql.GraphqlErrorException$Builder.build(GraphqlErrorException.java:58)",
                  "    at nz.co.sky.digital.exp.graphql.common.DataFetchers.errorException(DataFetchers.java:72)",
                  "    at nz.co.sky.digital.exp.graphql.common.DataFetchers.errorResult(DataFetchers.java:45)",
                  "    ... 93 more"
                ],
                "classification": "DataFetchingException"
              }
            }
          ],
          "data": {
            "group": null
          }
        }

   Type 2: Data null value
   {
      "errors": [
        {
          "message": "Unexpected error occurred",
          "locations": [
            {
              "line": 2,
              "column": 2
            }
          ],
          "path": [
            "group"
          ],
          "extensions": {
            "errorId": "9ef691af-cc84-46cd-a4e1-25ed37c5f72d",
            "classification": "DataFetchingException"
          }
        }
      ],
      "data": null
}
 *
 */
var isErrorResponse = function (response) {
    var data = getResponseData(response);
    var isAllValuesNull = !data || Object.values(data).every(function (value) { return value === null; });
    return !!response.errors && isAllValuesNull;
};
exports.successHandler = function (dispatch, response, successType, errorType, meta, onSuccess, onError, hasResponseData) {
    if (meta === void 0) { meta = undefined; }
    return __awaiter(void 0, void 0, void 0, function () {
        var res, err, errorAction, data, successAction;
        return __generator(this, function (_a) {
            if (hasResponseData && isErrorResponse(response)) {
                err = new ResponseError_1.default();
                errorAction = { type: errorType, payload: err, meta: meta, error: true };
                res = dispatch(errorAction);
                if (onError) {
                    onError(dispatch, { payload: err, meta: meta });
                }
                // if request fails...
                logging_1.default.captureException(err);
            }
            else {
                data = getResponseData(response);
                successAction = {
                    type: successType,
                    payload: data,
                    meta: meta,
                    etag: getResponseEtag(response),
                };
                res = dispatch(successAction);
                if (onSuccess) {
                    onSuccess(dispatch, { payload: data, meta: meta });
                }
            }
            return [2 /*return*/, res];
        });
    });
};
exports.errorHandler = function (dispatch, error, successType, errorType, authErrorType, meta, onError, requestParams) {
    if (meta === void 0) { meta = undefined; }
    return __awaiter(void 0, void 0, void 0, function () {
        var err, sentryError, _a, resStatus, json, apiError, status, message, code, isJwtRevoked, errorAction, res;
        var _b, _c, _d, _e;
        return __generator(this, function (_f) {
            if (error.response) {
                _a = error.response, resStatus = _a.status, json = _a.data;
                apiError = json === null || json === void 0 ? void 0 : json.error;
                status = (apiError === null || apiError === void 0 ? void 0 : apiError.status) ? parseInt(apiError === null || apiError === void 0 ? void 0 : apiError.status, 10) : resStatus;
                message = (_b = apiError === null || apiError === void 0 ? void 0 : apiError.message) !== null && _b !== void 0 ? _b : error.message;
                code = (_c = apiError === null || apiError === void 0 ? void 0 : apiError.code) !== null && _c !== void 0 ? _c : error.code;
                /*
                 * The request was made and the server responded with a
                 * status code that falls out of the range of 2xx
                 */
                if (status === 304) {
                    // do nothing if response is not modified
                    dispatch({ type: successType, etag: getResponseEtag(error.response), meta: meta, payload: null });
                    return [2 /*return*/];
                }
                if (status === 401 || status === 403) {
                    isJwtRevoked = status === 403 && ((_e = (_d = error.response) === null || _d === void 0 ? void 0 : _d.error) === null || _e === void 0 ? void 0 : _e.code) === 'JWT_REVOKED';
                    err = new errors_1.UnauthorizedError(isJwtRevoked ? 'JWT_REVOKED' : message, code); // Update the error message to help identify JWT_REVOKED errors via the Redux auth.error selector
                    dispatch({ type: authErrorType, payload: err, meta: meta, error: true });
                    if (isJwtRevoked) {
                        logging_1.default.captureMessage({
                            message: 'JWT revoked - user logged out',
                            level: 'info',
                            code: status,
                        });
                        return [2 /*return*/];
                    }
                }
                else {
                    err = new errors_1.APIError(message, status, code);
                }
                sentryError = new errors_1.APIError(message.replace(/\s|\\n/g, '').slice(0, 120) + requestParams, status, code);
            }
            else if (utils_1.isNotNilOrEmpty(error === null || error === void 0 ? void 0 : error.message) &&
                ((error === null || error === void 0 ? void 0 : error.message) === 'Network request failed' || (error === null || error === void 0 ? void 0 : error.message.includes('android_getaddrinfo')))) {
                // This block is for capturing network related errors.
                // At the moment the error messages are the most common errors in sentry.
                err = new errors_1.NetworkError(error === null || error === void 0 ? void 0 : error.message);
                sentryError = new errors_1.NetworkError((error === null || error === void 0 ? void 0 : error.message) + requestParams);
            }
            else {
                err = new errors_1.RequestError(error === null || error === void 0 ? void 0 : error.message);
                sentryError = new errors_1.RequestError((error === null || error === void 0 ? void 0 : error.message) + requestParams);
            }
            logging_1.default.captureException(sentryError);
            errorAction = { type: errorType, payload: err, meta: meta, error: true };
            res = dispatch(errorAction);
            if (onError) {
                onError(dispatch, { payload: err, meta: meta });
            }
            return [2 /*return*/, res];
        });
    });
};
//# sourceMappingURL=handlers.js.map